export const getDaysWithoutIncidentsService = (fetch) => async () => {
  try {
    const response = await fetch({
      url: "/api/v1/dashboard/days-without-incidents",
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
